import React, { useState } from 'react'
import { Button, CircularProgress, Modal, Paper, TextField, Typography } from '@material-ui/core'
import { forgotPasswordApiCall } from '../service/client'

export default function ForgotModal(props) {
  const { showModal, hideModal } = props

  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [requested, setRequested] = useState(false)

  function submit() {
    setLoading(true)
    forgotPasswordApiCall(email).then(r => {
      setRequested(true)
      setLoading(false)
    })
  }

  return (
    <Modal
      open={showModal}
      onClose={hideModal}
      aria-labelledby="User Modal"
      aria-describedby="Add or edit users"
    >
      <Paper style={{ margin: 'auto', marginTop: '10%', width: 400 }}>
        <Typography style={{ padding: 10 }} variant="h4" color="primary">Password Reset</Typography>
        <div style={{  padding: 30, paddingTop: 0, height: 200 }}>
          {requested ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column', gap: 10 }}>
              <Typography style={{ padding: 10 }} variant="h6" color="primary">Request Submitted</Typography>
              <div>
                If your account exists, a reset link is on it's way.
              </div>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column', gap: 10 }}>
              <div>Enter your email to reset your password</div>
              <TextField value={email} onChange={e => setEmail(e.target.value)} variant='outlined' fullWidth />
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={submit}
                disabled={loading}
              >
                {
                  loading ? (
                    <CircularProgress color="inherit"/>
                  ) : 'Reset'
                }
              </Button>
            </div>
          )}
        </div>
      </Paper>
    </Modal>
  )
}